import React, { useContext, useState } from "react";
import "./style.css";

import { Title } from "../../Components/Atoms";
import { AuthContext } from "../../Library/contexts";
import { Switch } from "@chakra-ui/react";

const Profile = () => {
  const { profile, assets } = useContext(AuthContext);
  const ACCESS_CODES = JSON.parse(window.localStorage.getItem("accessCodes"));

  const [ isDarkTheme, setIsDarkTheme ] = useState(!window.localStorage.getItem("theme"));

  const profileDetails = [
    { key: "Mobile", value: profile.mob },
    { key: "Email", value: profile.eml },
    { key: "Address", value: profile.add },
    { key: "GST Number", value: profile.gstno || "-" },
  ];

  const renderDetails = () => {
    return ((profile && profile.length) ? profile : profileDetails).map((detail) => (
      <div key={detail.key} className="panel-card-item">
        <label>{detail.key}:</label>
        <span>{detail.value}</span>
      </div>
    ));
  };

  const handleThemeSwitching = (checked) => {
    if (!checked) {
      document.body.classList.add("Ev-Light-Theme-Container");
      window.localStorage.setItem("theme", "light");
    } else {
      document.body.classList.remove("Ev-Light-Theme-Container");
      window.localStorage.removeItem("theme");
    }

    setIsDarkTheme(!isDarkTheme);
  }

  return (
    <main className="panel-card-center profile">
      {/* { (ACCESS_CODES && ACCESS_CODES.length) ? <div className="theme-switcher">
        <p>Dark Mode</p>
        <Switch size='md' isChecked={isDarkTheme} onChange={(event) => handleThemeSwitching(event.target.checked)} className={""} />
      </div> : null } */}

      <article className="panel-card">
        <Title>{assets.brandNm || profile.brandNm}</Title>

        <div className="mt-16 panel-card-details">
          {renderDetails()}
        </div>
      </article>
    </main>
  )
}

export default Profile
